@if (title) {
<h3>{{ title }}</h3>
}
<div class="workflow d-flex">
  <ng-content></ng-content>
</div>
